import { useEffect, useState } from 'react';
// apis
import { getDisabledPos } from 'api';
// utils && hooks
import { useDebounce } from 'utils/hooks';
import { columnsWithClient, transformDataPosTable } from 'utils/aux/transformerData';

const useTableHooks = () => {
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const [clientIdFilter, setClientIdFilter] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({ total: 1, per_page: 20, total_pages: 1, current_page: 1 });
    const [sort, setSort] = useState('id');
    const [ordering, setOrdering] = useState('asc');
    const searchValueDebounced = useDebounce(searchValue, 500);

    const fetch = async (rows: number, page: number, sort: string, search: string, clientId?: any[]) => {
        setIsLoading(true);
        getDisabledPos({
            rows,
            page,
            sort,
            search: search,
            clientId: clientId?.join(',') || '',
        })
            .then((response) => {
                setData((prevState) => transformDataPosTable(response?.data?.data));
                if (response?.data?.meta?.pagination) {
                    setPagination((prevState) => response?.data?.meta?.pagination);
                }
            })
            .catch((e) => console.error(e))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (!isLoading && sort && ordering) {
            fetch(20, 1, `${sort}:${ordering}`, searchValueDebounced, clientIdFilter);
        }
    }, [searchValueDebounced]);

    // client filter
    const resetClientFilter = () => {
        setClientIdFilter((prev) => []);
        fetch(20, 1, `${sort}:${ordering}`, searchValueDebounced);
    };

    const handleFetchWithClient = () => {
        return fetch(20, 1, `${sort}:${ordering}`, searchValueDebounced, clientIdFilter);
    };

    // sort
    const handleSortChange = (sortColumn, sortType) => {
        setSort(sortColumn);
        setOrdering(sortType);
        fetch(20, 1, `${sortColumn}:${sortType}`, searchValueDebounced, clientIdFilter);
    };

    // change page
    const handleChangePage = (newPage) => {
        fetch(20, newPage, `${sort}:${ordering}`, searchValueDebounced, clientIdFilter);
    };

    // change limit
    const handleChangeLimit = (newLimit) => {
        fetch(newLimit, 1, `${sort}:${ordering}`, searchValueDebounced, clientIdFilter);
    };

    return {
        isLoading,
        searchValue,
        columns: columnsWithClient,
        data,
        setSearchValue,
        clientIdFilter,
        setClientIdFilter,
        pagination,
        resetClientFilter,
        handleSortChange,
        ordering,
        sort,
        handleFetchWithClient,
        handleChangePage,
        handleChangeLimit,
    };
};

export default useTableHooks;
